export enum VehicleTypes {
  Bike = 1, // Vélo
  ElectricBike = 2, // Vélo électrique
  ElectricScooter = 3, // Trottinette électrique
  ElectricUnicycle = 4, // Gyroroue
  Segway = 5, // Gyropode
  ElectricBalanceBike = 6, // Draisienne électrique
  Hoverboard = 7, // Hoverboard
}
